import * as React from "react";
import * as cn from "classnames";

import "./Warning.css";

export interface WarningProps {
    className?: string;
    title: string;
    text: string;
}

export const Warning = (props: WarningProps) => (
    <span className={cn("warning-msg", props.className)}>
        <span className="warning_title">{props.title}</span>
        <span className="warning_text">{props.text}</span>
        <span className="warning_triangle" />
    </span>
);
